customElements.get('product-form') ||
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.formIdInput = this.form.querySelector('[name=id]');
        this.formIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.stickyAtcButton = document.getElementById(`StickyAtcSubmitButton-${this.dataset.section}`);
        this.skipCart = this.formIdInput.dataset.skipCart === 'true';
        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }
        this.bundleDeals = document.getElementById(`bundle-deals-${this.dataset.section}`);
        this.quantityBreaks = document.getElementById(`quantity-breaks-${this.dataset.section}`);
        this.customFields = document.querySelectorAll(`[id^='CustomField-${this.dataset.section}-']`);
        this.variantInputs = this.form.querySelector('.product-form__variants');
      }

      getFreeGiftsEl() {
        return document.querySelector('free-gifts');
      }

      onSubmitHandler(event) {
        if (event) event.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        if (this.stickyAtcButton) {
          this.stickyAtcButton.classList.add('loading');
          this.stickyAtcButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        }

        let usingItemsArray = false;
        if (this.variantInputs) this.variantInputs.innerHTML = '';

        if (this.bundleDeals) {
          let html = '';
          usingItemsArray = true;
          for (let i = 0; i < this.bundleDeals.formVariants.length; i++) {
            const variant = this.bundleDeals.formVariants[i];
            html += `<input type="hidden" name="items[${i}][quantity]" value="${variant.quantity}">`;
            html += `<input type="hidden" name="items[${i}][id]" value="${variant.id}">`;
          }
          this.variantInputs.innerHTML = html;
        } else if (this.quantityBreaks && this.variantInputs && this.quantityBreaks.formVariants.length > 0) {
          let html = '';
          usingItemsArray = true;
          for (let i = 0; i < this.quantityBreaks.formVariants.length; i++) {
            const variant = this.quantityBreaks.formVariants[i];
            html += `<input type="hidden" name="items[${i}][quantity]" value="${variant.quantity}">`;
            html += `<input type="hidden" name="items[${i}][id]" value="${variant.id}">`;
            this.customFields.forEach((field) => {
              html += `<input type="hidden" name="items[${i}][properties][${field.fieldName}]" value="${field.prevValue}">`;
            });
          }
          this.variantInputs.innerHTML = html;
        }

        // Append free gifts + checked upsells to the same /cart/add payload
        const freeGifts = this.getFreeGiftsEl();
        const extras = freeGifts && typeof freeGifts.getAtcExtraItems === 'function' ? freeGifts.getAtcExtraItems() : [];

        if (extras.length && this.variantInputs) {
          if (!usingItemsArray) {
            // Convert single product add into items[] so we can attach extras
            const mainId = this.formIdInput.value;
            let mainQty = 1;
            const qtyInput = this.form.querySelector('[name="quantity"]');
            if (qtyInput && qtyInput.value) {
              mainQty = parseInt(qtyInput.value, 10) || 1;
            }
            // Prefer selected quantity-break qty when formVariants wasn't populated
            if (this.quantityBreaks) {
              const checked = this.quantityBreaks.querySelector('input[type="radio"]:checked');
              if (checked) {
                const breakEl =
                  checked.closest('[data-quantity]') || checked.closest('.quantity-break');
                const fromBreak = parseInt(
                  (breakEl && breakEl.dataset.quantity) || checked.value || checked.dataset.quantity,
                  10
                );
                if (!isNaN(fromBreak) && fromBreak > 0) mainQty = fromBreak;
              }
            }
            if (freeGifts && typeof freeGifts.getSelectedQuantity === 'function') {
              const fromGifts = freeGifts.getSelectedQuantity();
              if (fromGifts > 0) mainQty = fromGifts;
            }
            let html = `<input type="hidden" name="items[0][id]" value="${mainId}">`;
            html += `<input type="hidden" name="items[0][quantity]" value="${mainQty}">`;
            this.customFields.forEach((field) => {
              html += `<input type="hidden" name="items[0][properties][${field.fieldName}]" value="${field.prevValue}">`;
            });
            this.variantInputs.innerHTML = html;
            usingItemsArray = true;
          }

          const startIndex = this.variantInputs.querySelectorAll('input[name^="items["][name$="[id]"]').length;
          this.variantInputs.insertAdjacentHTML('beforeend', freeGifts.buildAtcItemsHtml(startIndex));
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        if (usingItemsArray) {
          const optionNames = this.dataset.options ? this.dataset.options.split(',') : [];
          const removeKeys = ['id', 'quantity', ...optionNames];
          removeKeys.forEach((key) => formData.delete(key));
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            if (this.skipCart) {
              window.location = '/checkout';
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form' });
            }
            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            if (this.stickyAtcButton) {
              this.stickyAtcButton.classList.remove('loading');
              this.stickyAtcButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
            }
            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) this.errorMessage.textContent = errorMessage;
      }
    }
  );
